import 'Assets/css/app.min.css'
import 'Assets/css/cn/style.min.css'
import video from 'Assets/images/dynamic-temperature-bg.mp4'
require("Assets/js/cn/index.min.js")
require("Assets/js/footer.js");